/** Лист модуль: только константы по типам журнальных документов — без импортов из barrel `index`. */

// Визуальный порядок для бух. журнала: КС-2В (2), Бухгалтерский АВР 3-2 (7), ЗКС / 3КС (6)
export const BUH_DOC_TYPE_IDS = [2, 7, 6];

/** `floor_map_document_type_id` для «Бухгалтерский АВР 3-2» (`floor_map_document_type_code` = BUH_AVR). */
export const FLOOR_MAP_DOC_TYPE_ID_BUH_AVR = 7;

/** М19 перерасход (`floor_map_document_type_code` = M19_OVER), см. комментарий к EXEC_DOC_TYPE_IDS. */
export const FLOOR_MAP_DOC_TYPE_ID_M19_OVER = 11;

// М19 (8), М19_перерасход (11), М29 (9), Акт принятия (4), Акт скрытых (5), Исполнит. схема (3), Исполнит. лист геодезиста (10)
export const EXEC_DOC_TYPE_IDS = [3, 4, 5, 8, 9, 10, 11, 12, 13];

/**
 * Подписи по `floor_map_document_type_id`, если из API имени ещё нет или строка из выборки пустая.
 */
export const UNSIGNED_DOC_TYPE_FALLBACK_LABEL = Object.freeze({
  2: "КС-2В",
  7: "Бухгалтерский АВР 3-2",
  6: "ЗКС / 3КС",
  3: "Исполнительная схема",
  4: "Акт приёмки работ",
  5: "Акт скрытых работ",
  8: "М19",
  9: "М29",
  10: "Исполнительный лист геодезиста",
  11: "M19",
  12: "Исполнительная документация №12",
  13: "Исполнительная документация №13",
});

/** Порядок chip'ов «Тип документа» и значений из URL — как в BUH_DOC_TYPE_IDS / EXEC_DOC_TYPE_IDS. */
export function sortFloorMapDocTypeIdsForTab(typeIds, tabName) {
  const order = tabName === "buh_docs" ? BUH_DOC_TYPE_IDS : EXEC_DOC_TYPE_IDS;
  const rank = (id) => {
    const n = Number(id);
    const i = order.indexOf(n);
    return i === -1 ? 999 : i;
  };
  return [...typeIds].sort((a, b) => rank(a) - rank(b));
}
